import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Modal } from 'antd';
import { Provider } from 'react-redux';
import { connect } from 'react-redux';
import { hideModal } from '../store/actions';
import { Icon, ThemeProvider } from 'dlweb-components';
import Modals from '../components/modals';
import { useResponsiveModal } from '../hooks';

const ModalRoot = ({store, $rootScope, modalType, hideModal, modalProps, modalContentProps = {}}) => {

  const modalRef = useRef(null);

  const [open, setOpen] = useState(false);
  const { x, y, width, height } = useResponsiveModal(undefined, undefined, 915, 1500);

  const openModal = useCallback(() => {
    setOpen(true);
  }, [])

  const closeModal = useCallback(() => {
    setOpen(false);
  }, [])

  useEffect(() => {
    modalType !== null ? openModal() : closeModal();
  }, [modalType, openModal, closeModal])

  const modalOptions = {
    open: open,
    onOk: closeModal, 
    onCancel: closeModal, 
    afterClose: hideModal,
    destroyOnClose: true,
    forceRender: true,
    responsive: false,
    maskClosable: false,
    footer: null
  }

  modalContentProps.workingFolder = $rootScope.workingFolder;

  const responsiveProps = modalProps.responsive ? {
    width: width,
    style: {
      top: y,
      left: x,
      height: height,
      width: width,
      minWidth: '915px',
      position: 'absolute',
    },
    styles: {
      body: { height: 'calc(100% - 25px)' }
    }
  } : {};

  if (modalType === 'ERROR') {
    return (
      <Provider store={store}>
        <Modal
          {...modalOptions}
          cancelButtonProps={{hidden: true}}
          {...modalProps}
        >
          <div style={{ display: 'flex'}}>
            <div style={{ width: '50px', color: '#ff4d4f' }}><Icon type="exclamation-circle" /></div>
            <div dangerouslySetInnerHTML={{ __html: modalContentProps.content }}></div>
          </div>
        </Modal>
      </Provider>

    )
  }
  if (modalType === 'IMPORT') {
    const ImportModal = Modals[modalType] || null;

    const importModalOptions = {
      open: open,
      afterClose: hideModal,
      destroyOnClose: true,
      forceRender: true,
      maskClosable: false,
      footer: null
    }

    return (
      <Provider store={store}>
        <ThemeProvider>
          <ImportModal
            closeModal={closeModal}
            modalRef={modalRef}
            modalOptions={importModalOptions} 
            modalProps={modalProps}
            responsiveProps={responsiveProps}
            angularScope={$rootScope}
            {...modalContentProps}
          >
          </ImportModal>
        </ThemeProvider>
      </Provider>
    )
  }
  else if (modalType === 'NEW_DOCUMENT') {
    const NewDocModal = Modals[modalType] || null;

    const importModalOptions = {
      open: open,
      afterClose: hideModal,
      destroyOnClose: true,
      forceRender: true,
      maskClosable: false,
      footer: null
    }

    return (
      <Provider store={store}>
        <ThemeProvider>
          <NewDocModal
            closeModal={closeModal}
            modalRef={modalRef}
            modalOptions={importModalOptions} 
            modalProps={modalProps}
            responsiveProps={responsiveProps}
            angularScope={$rootScope}
            {...modalContentProps}
          >
          </NewDocModal>
        </ThemeProvider>
      </Provider>
    )
  }
  else {
    const ModalContents = Modals[modalType] || null;

    return (
      <Provider store={store}>
        <ThemeProvider>
          <Modal
            innerRef={modalRef}
            {...modalOptions}
            {...modalProps}
            {...responsiveProps}
          >
            {modalType && <ModalContents hideModal={closeModal} angularScope={$rootScope} {...modalContentProps} />}
          </Modal>
        </ThemeProvider>
      </Provider>
    )
  }
}

const mapStateToProps = state => state.modal;
const mapDispatchToProps = { hideModal };

export default connect(mapStateToProps, mapDispatchToProps)(ModalRoot);